import React, { useState, useEffect } from 'react';
import { Form } from "react-bootstrap";

// Helper function to generate ISO date string for a given option
const getISODateForOption = (optionValue, referenceDateInput) => {
    const referenceDate = referenceDateInput ? new Date(referenceDateInput.getTime()) : new Date();
    let date = new Date(referenceDate.getTime()); // Clone the reference date

    switch (optionValue) {
        case "1DAY":
            date.setDate(date.getDate() + 1);
            date.setHours(23, 59, 59, 999);
            return date.toISOString();
        case "3DAY":
            date.setDate(date.getDate() + 3);
            date.setHours(23, 59, 59, 999);
            return date.toISOString();
        case "END_OF_WEEK":
            const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)
            // If today is Sunday (dayOfWeek === 0), daysUntilSunday should be 0 to mean end of today.
            // Otherwise, it's 7 - dayOfWeek to get to next Sunday.
            const daysUntilSunday = (dayOfWeek === 0) ? 0 : (7 - dayOfWeek);
            date.setDate(date.getDate() + daysUntilSunday);
            date.setHours(23, 59, 59, 999);
            return date.toISOString();
        case "END_OF_NEXT_WEEK":
            // Days to current Sunday + 7 more days for next Sunday.
            // If today is Sunday, dayOfWeek is 0. (7-0) gets to next Sunday. Add 7 for next one.
            // No, if today is Sunday, it's 7 days to NEXT sunday.
            let daysUntilNextSunday = 7 - date.getDay();
            if (date.getDay() === 0) { // If today is Sunday
                daysUntilNextSunday = 7;
            } else {
                daysUntilNextSunday = 7 - date.getDay() + 7;
            }
            date.setDate(date.getDate() + daysUntilNextSunday);
            date.setHours(23, 59, 59, 999);
            return date.toISOString();
        case "END_OF_NEXT_2_WEEKS":
            let daysUntilNextTwoSundays = 7 - date.getDay() + 7; // Default to end of next week
             if (date.getDay() === 0) { // If today is Sunday
                daysUntilNextTwoSundays = 14; // 14 days to Sunday in two weeks
            } else {
                daysUntilNextTwoSundays = 7 - date.getDay() + 14; // Days to current week's Sunday + 14
            }
            date.setDate(date.getDate() + daysUntilNextTwoSundays);
            date.setHours(23, 59, 59, 999);
            return date.toISOString();
        case "END_OF_MONTH":
            date.setMonth(date.getMonth() + 1);
            date.setDate(0); // Sets to the last day of the current month (by setting day to 0 of next month)
            date.setHours(23, 59, 59, 999);
            return date.toISOString();
        case "ALL":
        default:
            return "";
    }
};

const ALL_OPTION_VALUE = "ALL";
const DATE_OPTIONS_VALUES = ["1DAY", "3DAY", "END_OF_WEEK", "END_OF_NEXT_WEEK", "END_OF_NEXT_2_WEEKS", "END_OF_MONTH"];

const TimeFilterStampSelector = ({ showStampWithinDateTime, setShowStampWithinDateTime }) => {
    const [currentSelectedOptionValue, setCurrentSelectedOptionValue] = useState(ALL_OPTION_VALUE);

    useEffect(() => {
        if (showStampWithinDateTime === "" || !showStampWithinDateTime) {
            setCurrentSelectedOptionValue(ALL_OPTION_VALUE);
            return;
        }

        let exactMatchFound = false;
        for (const optionVal of DATE_OPTIONS_VALUES) {
            if (getISODateForOption(optionVal, new Date()) === showStampWithinDateTime) {
                setCurrentSelectedOptionValue(optionVal);
                exactMatchFound = true;
                break;
            }
        }

        if (exactMatchFound) {
            return;
        }

        const targetDate = new Date(showStampWithinDateTime);
        if (isNaN(targetDate.getTime())) {
            setCurrentSelectedOptionValue(ALL_OPTION_VALUE);
            return;
        }

        let bestFallbackOption = ALL_OPTION_VALUE;
        let smallestTimeDiff = Infinity;

        for (const optionVal of DATE_OPTIONS_VALUES) {
            const optionDateStr = getISODateForOption(optionVal, new Date());
            if (!optionDateStr) continue; 

            const optionDate = new Date(optionDateStr);
            if (isNaN(optionDate.getTime())) continue;

            const diff = Math.abs(targetDate.getTime() - optionDate.getTime());

            if (diff < smallestTimeDiff) {
                smallestTimeDiff = diff;
                bestFallbackOption = optionVal;
            }
        }
        setCurrentSelectedOptionValue(bestFallbackOption);

    }, [showStampWithinDateTime]);

    const handleSelectionChange = (newlySelectedOptionValue) => {
        const isoString = getISODateForOption(newlySelectedOptionValue, new Date());
        setShowStampWithinDateTime(isoString);
    };

    return (
        <div className="StampSwitcher">
            <Form.Select onChange={(e) => handleSelectionChange(e.target.value)} value={currentSelectedOptionValue}>
                <option value="ALL">All</option>
                <option value="1DAY">1 day</option>
                <option value="3DAY">3 days</option>
                <option value="END_OF_WEEK">End of Week</option>
                <option value="END_OF_NEXT_WEEK">End of Next Week</option>
                <option value="END_OF_NEXT_2_WEEKS">End of Next 2 Weeks</option>
                <option value="END_OF_MONTH">End of Month</option>
            </Form.Select>
        </div>
    );
};

export default React.memo(TimeFilterStampSelector);